module.exports = __webpack_public_path__ + "static/mobile-tabbed-arrow-left.4f51948c.svg";